import {EcommerceSettingsService, SiteStore} from '@wix/wixstores-client-storefront-sdk';
import {PaymentRequestSettingsApi} from '../../apis/paymentRequest/PaymentRequestSettingsApi';
import {StoreCheckoutSettings} from '@wix/wixstores-graphql-schema-node';
import {PaymentRequestSettingsModel} from '../../models/paymentRequest/PaymentRequestSettings.model';
import {CheckoutOrigin} from '../../utils/common/bi.util.common';
import {SPECS} from '../../../common/constants';

export class PaymentRequestSettingsService {
  private readonly siteStore: SiteStore;
  private readonly paymentRequestSettingsApi: PaymentRequestSettingsApi;
  public paymentRequestSettings!: PaymentRequestSettingsModel;
  private readonly eCommerceSettingsService?: EcommerceSettingsService;

  constructor({
    siteStore,
    eCommerceSettingsService,
  }: {
    siteStore: SiteStore;
    eCommerceSettingsService?: EcommerceSettingsService;
  }) {
    this.siteStore = siteStore;
    this.paymentRequestSettingsApi = new PaymentRequestSettingsApi({siteStore, origin: CheckoutOrigin.paymentRequest});
    this.eCommerceSettingsService = eCommerceSettingsService;
  }

  public async fetchSiteSettings(): Promise<void> {
    const shouldUseEcommerceSettings = this.siteStore.experiments.enabled(SPECS.UseEcommerceSettingsInCheckout);
    const ecommerceSettings = shouldUseEcommerceSettings
      ? await this.eCommerceSettingsService?.getEcommerceSettings({shouldWarmupData: true})
      : undefined;
    const paymentRequestSettings: StoreCheckoutSettings | undefined = !shouldUseEcommerceSettings
      ? await this.paymentRequestSettingsApi.getPaymentRequestSettings()
      : undefined;
    this.paymentRequestSettings = new PaymentRequestSettingsModel({
      paymentRequestSettings,
      ecommerceSettings,
      shouldUseEcommerceSettings,
    });
  }

  public async init(): Promise<void> {
    await this.fetchSiteSettings();
  }
}
